export const isNonPatientUser = (user) => !!user?.kind && user.kind !== 'patient';
